import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "nw-theme"

function resolveTheme(theme) {
  if (theme === "auto") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  }

  return theme
}

export default class extends Controller {
  connect() {
    this.theme = localStorage.getItem(STORAGE_KEY) || "dark"
    this.apply()
    this.mediaHandler = () => {
      if (this.theme === "auto") this.apply()
    }
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", this.mediaHandler)
  }

  disconnect() {
    window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", this.mediaHandler)
  }

  setLight() {
    this.setTheme("light")
  }

  setDark() {
    this.setTheme("dark")
  }

  toggleTheme() {
    const resolved = resolveTheme(this.theme)
    this.setTheme(resolved === "dark" ? "light" : "dark")
  }

  setTheme(value) {
    this.theme = value
    localStorage.setItem(STORAGE_KEY, value)
    this.apply()
    document.dispatchEvent(new CustomEvent("nw:theme-change", { detail: { theme: this.theme } }))
  }

  apply() {
    const resolved = resolveTheme(this.theme)
    document.documentElement.setAttribute("data-bs-theme", resolved)
    document.documentElement.setAttribute("data-nw-theme", this.theme)
  }
}
